import { render, staticRenderFns } from "./fav.vue?vue&type=template&id=fa75ac92&scoped=true&lang=pug&"
import script from "./fav.vue?vue&type=script&lang=js&"
export * from "./fav.vue?vue&type=script&lang=js&"
import style0 from "./fav.vue?vue&type=style&index=0&id=fa75ac92&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa75ac92",
  null
  
)

export default component.exports